import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubjectManagmentService } from 'src/app/Services/subject-management/subject-management.service';
import { CourseManagementHttpService } from '../../exam-management/exam-agencies/course-add-edit/services/course-http.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { ToastrService } from 'ngx-toastr';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { NavigationExtras, Router } from '@angular/router';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { IGetCodes } from 'src/app/interfaces/codes';

@Component({
  selector: 'app-content-management-navigator',
  templateUrl: './content-management-navigator.component.html',
  styleUrls: ['./content-management-navigator.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ContentManagementNavigatorComponent implements OnInit {
  @Input() route: string;
  @Input() param: string;
  selectionForm: FormGroup;

  examAgencies: any[] = [];

  courses: any[] = [];

  years: any[] = [];
  loggedInUser: any;
  selectbutton = true;
  getCourseSubjects: any[] = [];
  showAlert = false;
  courseCategory: IGetCodes | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private subjectService: SubjectManagmentService,
    private contentService: ContentManagementService,
    private courseMasterService: CourseManagementHttpService,
    private examService: ExamManagementService,
    private readonly toaster: ToastrService,
    private router: Router
  ) {
    this.retrieveLoggedInUserId();
  }

  ngOnInit(): void {
    this.selectionForm = this.fb.group({
      examAgency: [''], // Default value
      course: [''],
      year: [''],
    });
    this.getExamAgencies();
  }

  getExamAgencies() {
    const data = {
      category: 'EXAM_AGENCY@CONTENT',
    };
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.examAgencies = [...res];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  getCourses(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      category: `EXAM_COURSE@${selectedValue}`,
    };
    this.selectbutton = true;
    this.selectionForm.get('course')?.reset();
    this.selectionForm.get('year')?.reset();
    this.showAlert = false;
    this.courses = [];
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.courses = [...res];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  getYears(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      category: `COURSE_YEAR@${selectedValue}`,
    };
    this.selectbutton = true;
    this.selectionForm.get('year')?.setValue('');
    this.years = [];
    this.showAlert = false;
    this.subjectService.getCodes(data).subscribe({
      next: (res) => {
        this.years = [...res];
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  getCourseSubject(event: Event) {
    // this.subjectSe
    const selectedValue = (event.target as HTMLSelectElement).value;
    const data = {
      LoggedInUserID: this.loggedInUser,
      CourseID: selectedValue,
    };
    this.examService.getExamInstanceSubject(data).subscribe({
      next: (res: any) => {
        this.getCourseSubjects = res?.data;
        if (this.getCourseSubjects.length > 0) {
          this.selectbutton = false;
          this.showAlert = false;
        } else {
          this.showAlert = true;
          this.selectbutton = true;
        }
        this.getCourseCategoryForCourse();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  getCourseCategoryForCourse() {
    const selectedValue = this.selectionForm.get('year')?.value;
    if (selectedValue) {
      this.courseMasterService
        .getDropdownListByCode(
          `COURSE_CATEGORY_TYPE_FROM_COURSEID@${selectedValue}`
        )
        .subscribe({
          next: (res) => {
            console.log(res);
            this.courseCategory = res[0];
          },
          error: (err) => {
            console.log(err);
          },
        });
    } else {
      this.selectbutton = true;
      this.showAlert = false;
    }
  }

  goToNextRoute(onCancel = false) {

    if(!this.selectionForm.get('year')?.value){
      this.toaster.error('Please fill all the fields for selection', 'Error');
      return;
    }
    const examAgency =
      this.examAgencies.find(
        (e) => e.Code === this.selectionForm.get('examAgency')?.value
      )?.Name || '';
    const courseName =
      this.courses.find(
        (e) => e.Code === this.selectionForm.get('course')?.value
      )?.Name || '';
    const examYear =
      this.years.find((e) => e.Code === this.selectionForm.get('year')?.value)
        ?.Name || '';

        // PRE-EVALUATION COURSE SELECTION HANDLING STARTS HERE
      if (this.param === 'QUESTION_PRE_EVALUATION_COURSE_SELECTION') {
      this.activeModal.close({
        courseId: onCancel ? null :this.selectionForm.get('year')?.value,
        examAgencyId: onCancel ? null :this.selectionForm.get('examAgency')?.value,
        courseName: onCancel ? null :courseName,
        examYear: onCancel ? null :examYear,
      });
      return;
    }
    // PRE-EVALUATION COURSE SELECTION HANDLING ENDS HERE
    const navigationExtras: NavigationExtras = {
      queryParams: {
        c_id: onCancel ? null :this.selectionForm.get('year')?.value,
        eA_Name: onCancel ? null :examAgency,
        c_Name: onCancel ? null : courseName,
        eY_Name: onCancel ? null : examYear,
        cM_id: onCancel ? null : this.selectionForm.get('course')?.value,
        eA_Id: onCancel ? null : this.selectionForm.get('examAgency')?.value,
        cC_Code: onCancel ? null : this.courseCategory ? this.courseCategory['Code'] : null,
        cC_Name: onCancel ? null : this.courseCategory
          ? this.courseCategory['Description']
          : null,
      },
      skipLocationChange: false,
      state: { value: this.selectionForm.get('year')?.value },
    };
    this.contentService.setQueryParams({
      c_id: this.selectionForm.get('year')?.value,
      eA_Name: onCancel ? null :examAgency,
      c_Name:onCancel ? null : courseName,
      eY_Name: onCancel ? null :examYear,
      cM_id: onCancel ? null :this.selectionForm.get('course')?.value,
      eA_Id: onCancel ? null :this.selectionForm.get('examAgency')?.value,
      cC_Code: onCancel ? null :this.courseCategory ? this.courseCategory['Code'] : null,
      cC_Name: onCancel ? null :this.courseCategory ? this.courseCategory['Description'] : null,
    });

    if (this.route) {
      if (this.param) {
        this.router.navigate([`${this.route}/${this.param}`], navigationExtras);
      } else {
        this.router.navigate([this.route], navigationExtras);
      }
    }

    this.activeModal.close();
  }

  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.loggedInUser = loggedInUserId;
    return null;
  }
}
